module.exports = __webpack_public_path__ + "files/ba602ea9336533d63f702d43fa9e67c8.png";